import { Link } from "react-router-dom";
import { ArrowUpRight, Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CREATORS = [
  { name: "Ava Sinclair", img: "/images/creator-ava.jpg" },
  { name: "Mia Reyes", img: "/images/creator-mia.jpg" },
  { name: "Nadia Cole", img: "/images/creator-nadia.jpg" },
  { name: "Sienna Vaughn", img: "/images/creator-sienna.jpg" },
  { name: "Lena Marx", img: "/images/creator-lena.jpg" },
  { coming: true },
];

export default function Creators() {
  return (
    <div className="pt-32">
      <section className="max-w-7xl mx-auto px-6 text-center" data-testid="creators-hero">
        <Reveal>
          <p className="overline text-gold mb-4">The Roster</p>
          <h1 className="font-display text-6xl md:text-8xl uppercase text-white">Our Creators</h1>
          <p className="mt-5 text-white/60 text-lg max-w-2xl mx-auto">
            A boutique, intentionally focused roster. We don't chase numbers — we build careers.
          </p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CREATORS.map((c, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              {c.coming ? (
                <div className="group relative overflow-hidden aspect-[3/4] border border-dashed border-gold/30 bg-gradient-to-br from-[#171203]/50 to-[#0a0a0a] flex flex-col items-center justify-center text-center" data-testid={`creator-coming-${i}`}>
                  <Plus className="text-gold/70 mb-4 transition-transform duration-500 group-hover:rotate-90" size={36} strokeWidth={1.4} />
                  <p className="overline text-gold mb-2">Now Recruiting</p>
                  <h3 className="font-display text-4xl uppercase text-white leading-none">More<br />2 Come</h3>
                </div>
              ) : (
                <div className="group relative overflow-hidden aspect-[3/4] border border-white/10" data-testid={`creator-${i}`}>
                  <img src={c.img} alt={c.name} className="h-full w-full object-cover object-top grayscale-[20%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
                    <h3 className="font-display text-3xl uppercase text-white leading-none">{c.name}</h3>
                    <ArrowUpRight className="text-white/60 group-hover:text-gold transition-colors" />
                  </div>
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-28 text-center">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl uppercase text-white">Want To Join The Roster?</h2>
          <Link to="/pricing" data-testid="creators-apply" className="mt-8 inline-flex bg-gold text-black px-10 py-4 overline hover:bg-[#F5D061] transition-colors duration-300">Apply Now</Link>
        </Reveal>
      </section>
    </div>
  );
}
